// extracted by mini-css-extract-plugin
export default {"tableHeader":"table_header-module___tableHeader___dfdeffac"};